import { Trans, useTranslation } from 'react-i18next';

function Help() {
	const { t } = useTranslation();
	return (
		<div className="z-10 flex flex-col items-center gap-4 py-8 text-center lg:container">
			<h3 className="whitespace-break-spaces font-title text-[32px] font-semibold leading-10 -tracking-[1px] lg:text-[40px] lg:font-bold lg:leading-[52px]">
				{t('unsubscribe.help.title')}
			</h3>
			<p className="lg:max-w-[606px]">
				<Trans
					t={t}
					i18nKey="unsubscribe.help.subtitle"
					components={{
						anchor: (
							// eslint-disable-next-line jsx-a11y/anchor-has-content
							<a
								className="text-red"
								target="_blank"
								rel="noopener noreferrer"
								href="mailto:support@pdfe.com"
							/>
						)
					}}
				/>
			</p>
			<p className="mt-2 text-sm text-grey-500 lg:max-w-[456px]">
				{t('unsubscribe.help.note')}
			</p>
		</div>
	);
}

export default Help;
